import SubTitle from '@/pages/WgqAllMaps/components/SubTitle';
import { formatThousandAndUnit, keepOneOrLine, keepPercentOneNull, keepWithNumberOrNull } from '@/utils/utils';
import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { getChartOption } from './charts';
import styles from './index.module.scss';
import titlePng from '@/assets/images/title_icon.png';
import { ShareDataUnityEnergyCockpitMapContext } from '../../../..';
import Marquee from '../../../RightBox/components/AlarmType/marquee';
import { formatName, getEnergyMediumColor, getEnergyMediumColorMap } from '@/pages/WgqAllMaps/utils';
export interface PieLegendProp {
  name: string;
  color: string;
  percent?: any;
  value?: any;
}

const CostAllocation = () => {
  const { energyCostData, energyCostDataLoading: loading } = useContext(ShareDataUnityEnergyCockpitMapContext);
  const [typePieLegendData, setTypePieLegendData] = useState<PieLegendProp[]>();

  const theme = useTheme();
  const chartRef = useRef(null);

  const energyMediumColorMap = useMemo(() => {
    const mediumList =
      energyCostData?.costFrom?.map(item => ({
        energyMediumId: item.energyMediumId,
        energyMediumName: item.energyMediumName,
      })) ?? [];

    return getEnergyMediumColorMap(mediumList);
  }, [energyCostData]);

  // 图表
  const chartOption = useMemo(() => {
    return getChartOption(energyCostData, energyMediumColorMap);
  }, [energyCostData, energyMediumColorMap]);

  useEffect(() => {
    setTypePieLegendData([
      ...(energyCostData?.costFrom?.map((item, index) => ({
        color: getEnergyMediumColor({
          energyMediumId: item.energyMediumId,
          energyMediumName: item.energyMediumName,
          colorMap: energyMediumColorMap,
          fallbackIndex: index,
        }),
        name: formatName(item.energyMediumName),
        value: keepWithNumberOrNull(item.charges),
        percent: keepPercentOneNull(item.percentage),
      })) ?? []),
    ]);
  }, [energyCostData, energyMediumColorMap]);
  return (
    <SubTitle title="成本去向" img={titlePng} style={{ flex: 6, paddingTop: 2 }} headerStyle={{ padding: 0 }}>
      <div className={styles.pie_wrapper}>
        <div className={styles.chart_wrapper}>
          {/* <div className={styles.title}>
          总成本（{formatThousandAndUnit(energyCostData?.charges).unit}元）:{' '}
          <span className={styles.value}>{formatThousandAndUnit(energyCostData?.charges).value}</span>{' '}
        </div> */}
          <EchartsWithTheme
            empty={{
              isShowEmpty: !energyCostData?.costFrom || energyCostData?.costFrom.length === 0,
              emptyNode: <Empty />,
            }}
            ref={chartRef}
            loading={loading}
            type="pie"
            theme={theme}
            style={{ height: '100%', flex: 1, minHeight: 240 }}
            option={chartOption}
          />
        </div>
        <div className={styles.customer_legend}>
          {(typePieLegendData ?? []).map(item => (
            <div className={styles.legend_item} key={item.name}>
              <div className={styles.icon} style={{ backgroundColor: item.color }}></div>
              <Marquee>{item.name ?? '-'}</Marquee>
              <div className={styles.proportion}>{keepOneOrLine(item.percent)}%</div>
              <div className={styles.value}>
                {formatThousandAndUnit(item.value)?.value}
                <span className={styles.unit}>{formatThousandAndUnit(item.value)?.unit}元</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SubTitle>
  );
};

export default CostAllocation;
